module.exports = __webpack_public_path__ + "img/dark-dirt-transition.0035b4d3.png";